import React from 'react';
import LiveIcon from '@/components/Icons/LiveIcon';

export interface LiveRadioPillProps {
  isActive?: boolean;
  isSmall?: boolean;
}

const LiveRadioPill: React.FC<LiveRadioPillProps> = ({ isActive = true, isSmall = false }) => {
  return (
    <div
      className={
        'animate-fadeIn flex items-center justify-center gap-1 rounded-full px-8 ' +
        `${isActive ? 'bg-primary-red' : 'bg-black-25'} ${isSmall ? 'py-8' : 'py-8 lg:w-100 lg:py-1'}`
      }
    >
      <LiveIcon strokeColor="white" />
      {!isSmall && (
        <p className="label-md my-[2px] ml-8 line-clamp-1 hidden font-extrabold text-white-100 lg:block">Í beinni</p>
      )}
    </div>
  );
};

export default LiveRadioPill;
